export const getSearchLocation = state => state.searchInput.searchLocation
export const getSearchLocationAddress = state => state.searchInput.searchLocation.address
export const getSelectedRange = state => state.searchInput.searchLocation.within
export const getVisitTypeId = state => state.searchInput.visitTypeId || '1341'
